import { render, staticRenderFns } from "./AudioControl.vue?vue&type=template&id=73bba571&scoped=true"
import script from "./AudioControl.vue?vue&type=script&lang=ts"
export * from "./AudioControl.vue?vue&type=script&lang=ts"
import style0 from "./AudioControl.vue?vue&type=style&index=0&id=73bba571&prod&lang=scss"
import style1 from "./AudioControl.vue?vue&type=style&index=1&id=73bba571&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bba571",
  null
  
)

export default component.exports